// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_customer.scss
// module id = 39
// module chunks = 0